import React from "react";

export const ErrorMessage: React.FC<{
  title: string;
  message?: string;
}> = (props) => {
  return (
    <div className='error-message__container'>
      <div className='error-message__title'>{props.title}</div>
      {props.message && <div className='error-message__message'>{props.message}</div>}
    </div>
  );
};
